import React from "react";
import { ThemeMenu2 } from "../Theme2/Theme2";
import { useParams } from "react-router-dom";

const Theme2 = ({ orgInfo, orgData }) => {
  const { orgcode, page } = useParams();
  return <>{orgcode && <ThemeMenu2 orgInfo={orgInfo} orgData={orgData} />}</>;
};

export { Theme2 };
